import { Environment } from './types';

export const environment: Environment = {
  flavor: 'sc',
  env: 'production',
  baseUrl: 'https://admin.schoolcamapp.com',
  contactEmail: 'support@schoolcamapp.com',
  auth: {
    popup: {
      timeout: 300000,
    },
  },
  dropbox: {
    clientId: '',
  },
  firebase: {
    options: {
      apiKey: 'AIzaSyBOKE2zacx9l_yYpV3UCNNaXnC67iXdj5o',
      authDomain: 'schoolcamnext-prod.firebaseapp.com',
      projectId: 'schoolcamnext-prod',
      storageBucket: 'schoolcamnext-prod.firebasestorage.app',
      messagingSenderId: '874151056571',
      appId: '1:874151056571:web:c23de78564600eeb5f059e',
      measurementId: 'G-XEDBF8JNK0',
    },
  },
  google: {
    clientId: '105877952594-iuhogcpluaujgj7o7oraq6j904nq3o02.apps.googleusercontent.com',
    apiKey: 'AIzaSyAwzYs3rsypB2yMJ39pLfT14sKOaYB1NV4',
  },
  microsoft: {
    clientId: '',
  },
  zoho: {
    clientId: '',
  },
  sentry: {
    domain: 'bitwise-software.sentry.io',
    dsn: 'https://47889825dce616637f219933abdbd02f@o474562.ingest.us.sentry.io/4507055702081536',
  },
  stripe: {
    publishableKey:
      'pk_live_51KWdJnAt9mdMGma59ikArbFqUx4m6WF2bQRRhgmQPpnALny4eY65ystxmk3gXlmJAAhCkHZ1GgPb4EjZJ6bvtFrj00W6fUmX22',
  },
};
